export const ChargingSpotsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5342 5.61797L14.5 10.5H17.0057C17.6151 10.5 18.1721 10.8443 18.4447 11.3893C18.7718 12.0436 18.6163 12.8363 18.0662 13.3186L10.0874 20.3128C9.44892 20.8724 8.4918 20.8626 7.86494 20.2901C7.34601 19.816 7.18024 19.0674 7.45056 18.4187L9.5 13.5H6.99068C6.38352 13.5 5.82848 13.157 5.55696 12.6139C5.22929 11.9586 5.38768 11.1645 5.94169 10.685L13.9531 3.75143C14.5574 3.22843 15.4511 3.2185 16.0668 3.72795C16.6213 4.18664 16.811 4.95373 16.5342 5.61797Z"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);
